import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { OracleLinkedService } from '../linkedservice/oracle.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.oracle.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Oracle_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Oracle_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: OracleLinkedService.MODEL
        }
    }
})
export class OracleTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
